import { render, staticRenderFns } from "./AddMerchantAppModal.vue?vue&type=template&id=b98749fe&scoped=true"
import script from "./AddMerchantAppModal.vue?vue&type=script&lang=js"
export * from "./AddMerchantAppModal.vue?vue&type=script&lang=js"
import style0 from "./AddMerchantAppModal.vue?vue&type=style&index=0&id=b98749fe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98749fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b98749fe')) {
      api.createRecord('b98749fe', component.options)
    } else {
      api.reload('b98749fe', component.options)
    }
    module.hot.accept("./AddMerchantAppModal.vue?vue&type=template&id=b98749fe&scoped=true", function () {
      api.rerender('b98749fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/develop-manage/components/Modal/AddMerchantAppModal.vue"
export default component.exports